// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"bbcec776","551":"023e031c","842":"d713aa50","851":"b314b9fa","879":"c75c939d"}[chunkId] + ".chunk.js";
};